import { useMemo } from "react";

import { useCreateAccountQuery } from "./createAccountQuery";

export interface StartPageConfig {
  // TODO: can get more granular (i.e. mail, email, text opt in)
  // I'm deferring for now
  allowUpdateNotificationPreferences: boolean;
  showTermsConditions: boolean;
  // TODO: can get more granular (e.g. which _parts_ of order summary to show?)
  showOrderSummary: boolean;
  customerInfo: {
    showBillingAddress: boolean;
  };
  endingBehavior: {
    action:
      | "GO_TO_SURVEY"
      | "GO_TO_WELCOME_PAGE"
      | "GO_TO_ENTERPRISE_INFO_PAGE";
  };
  // business context here:
  // https://mighteor.atlassian.net/browse/MW-6190
  showMcsConsentToTreat: boolean;
}

const PAGE_CONFIG_GREENSHIELD: StartPageConfig = {
  allowUpdateNotificationPreferences: true,
  showTermsConditions: true,
  showOrderSummary: false,
  customerInfo: {
    showBillingAddress: false,
  },
  endingBehavior: {
    action: "GO_TO_SURVEY",
  },
  showMcsConsentToTreat: false,
};

const PAGE_CONFIG_STANDARD_CHECKOUT: StartPageConfig = {
  allowUpdateNotificationPreferences: false,
  showTermsConditions: false,
  showOrderSummary: true,
  customerInfo: {
    showBillingAddress: true,
  },
  endingBehavior: {
    action: "GO_TO_WELCOME_PAGE",
  },
  showMcsConsentToTreat: false,
};

const PAGE_CONFIG_MCS: StartPageConfig = {
  allowUpdateNotificationPreferences: false,
  showTermsConditions: false,
  showOrderSummary: true,
  customerInfo: {
    showBillingAddress: true,
  },
  endingBehavior: {
    action: "GO_TO_WELCOME_PAGE",
  },
  showMcsConsentToTreat: true,
};

const PAGE_CONFIG_ENTERPRISE: StartPageConfig = {
  ...PAGE_CONFIG_STANDARD_CHECKOUT,
  endingBehavior: {
    action: "GO_TO_ENTERPRISE_INFO_PAGE",
  },
};

export const _getPageConfigForAccountTag = (
  programPlanTagsCsv: string | undefined,
): StartPageConfig | undefined => {
  if (programPlanTagsCsv === undefined) {
    return;
  }

  if (programPlanTagsCsv.includes("GREENSHIELD")) {
    return PAGE_CONFIG_GREENSHIELD;
  }

  if (programPlanTagsCsv.includes("MCS")) {
    return PAGE_CONFIG_MCS;
  }

  if (programPlanTagsCsv.includes("SPRING_HEALTH")) {
    return PAGE_CONFIG_ENTERPRISE;
  }

  return PAGE_CONFIG_STANDARD_CHECKOUT;
};

export const useStartPageConfig = (): StartPageConfig | undefined => {
  const { data: lambdaResp } = useCreateAccountQuery();
  const programPlanTagsCsv = lambdaResp?.order.program_plan_obj.tag;

  return useMemo<StartPageConfig | undefined>(
    () => _getPageConfigForAccountTag(programPlanTagsCsv),
    [programPlanTagsCsv],
  );
};
